import { useAppForm } from '@/shared/lib/form';
import { FIELD_MAX_LENGTHS } from '@/shared/constants';
import { Button, Text } from '@noorden-insurtech/alba-design-system';
import { revalidateLogic } from '@tanstack/react-form';
import { Link } from '@tanstack/react-router';
import { loginFormSchema, LoginFormValues } from '../schemas/login.schema';
import { normalizeEmail } from '@/shared/utils/normalize-email.util';

interface LoginFormProps {
  onSubmit: (values: LoginFormValues) => Promise<void>;
}

export function LoginForm({ onSubmit }: LoginFormProps) {
  const { AppField, handleSubmit, Subscribe } = useAppForm({
    defaultValues: {
      email: '',
      password: '',
    },
    onSubmit: async ({ value }) => {
      await onSubmit({ ...value, email: normalizeEmail(value.email) });
    },
    validationLogic: revalidateLogic(),
    validators: {
      onDynamic: loginFormSchema,
    },
  });

  return (
    <form
      onSubmit={e => {
        e.preventDefault();
        e.stopPropagation();
        handleSubmit();
      }}
      className='flex flex-col gap-6 w-full'
    >
      <AppField
        name='email'
        children={field => (
          <field.InputField
            label='E-mail'
            helperText=''
            type='email'
            lowercase
            placeholder='Digite seu e-mail'
            required
            maxLength={FIELD_MAX_LENGTHS.email}
          />
        )}
      />

      <div className='flex flex-col gap-2'>
        <AppField
          name='password'
          children={field => (
            <field.InputField
              label='Senha'
              helperText=''
              type='password'
              placeholder='Digite sua senha'
              required
              maxLength={FIELD_MAX_LENGTHS.password}
            />
          )}
        />
        <Link to='/forgot' className='self-start'>
          <Text className='text-[#2C2864] text-[12px] leading-[100%] font-normal hover:underline'>
            Esqueci minha senha
          </Text>
        </Link>
      </div>

      <Subscribe
        selector={state => [state.canSubmit, state.isSubmitting]}
        children={([canSubmit, isSubmitting]) => (
          <Button
            disabled={!canSubmit}
            type='submit'
            variant='primary'
            size='large'
            className='w-full'
          >
            {isSubmitting ? 'Entrando...' : 'Entrar'}
          </Button>
        )}
      />
    </form>
  );
}
